import { render } from "./KeywordManagement.vue?vue&type=template&id=5601f496&scoped=true"
import script from "./KeywordManagement.vue?vue&type=script&lang=js"
export * from "./KeywordManagement.vue?vue&type=script&lang=js"

import "./KeywordManagement.vue?vue&type=style&index=0&id=5601f496&scoped=true&lang=scss"
import "./KeywordManagement.vue?vue&type=style&index=1&id=5601f496&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5601f496"]])

export default __exports__